import * as React from 'react';
import { IconButton, FontIcon } from 'material-ui';
import { grey500 } from 'material-ui/styles/colors';
var actionStyle = {
    float: 'right'
};
var NoteAction = function (props) { return (React.createElement(IconButton, { style: actionStyle, tooltip: props.tooltip, tooltipPosition: "top-center", onClick: function (e) { return props.onClick(props.note); } },
    React.createElement(FontIcon, { color: grey500, className: "material-icons" }, props.icon))); };
export default NoteAction;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskNoteAction.tsx
// module id = 749
// module chunks = 0